
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Providers": () => {
return Promise.all(/*  | __federation_expose_Providers */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("422"), __webpack_require__.e("731")]).then(() => (() => (__webpack_require__(84))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };